import { savingsCategoriesService, SavingsCategoriesResponse } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

export const SAVINGS_CATEGORIES_QUERY_KEY = 'savingsCategories';

/**
 * Fetches savings categories for the given scope: omit companyId for the global set, or pass a
 * companyId to read that company's set (falling back to global server-side if it has none).
 */
const useFetchSavingsCategories = (companyId?: string, enabled = true) =>
  useQuery<SavingsCategoriesResponse, Error>({
    queryKey: [SAVINGS_CATEGORIES_QUERY_KEY, companyId ?? null],
    queryFn: () => savingsCategoriesService.fetchSavingsCategories({ companyId }),
    enabled,
  });

export default useFetchSavingsCategories;
